//====== WR data 30/09/2026 — SmartFlow Importer: Pré-requisitos (BBP) — gravação REAL no SAP
// Business One (Service Layer) de Depósitos/Grupos de Item/Grupos de Parceiro de Negócio, mesmo
// padrão de itemSapWrite.js/smartflowSapWrite.js (SAP mandante). Pedido do usuário: antes só se
// montava a lista pra referência; agora o que for marcado "incluir" e ainda não existir no SAP
// (origem !== "sap") é criado de verdade antes de liberar Item/Parceiro (ver handleConfirmar em
// SmartFlowPreRequisitosForm.js).
//======
import apiSap from "services/sapApi"

function sapUrl(serviceLayerUrl, path) {
  return String(serviceLayerUrl || "").replace(/\/$/, "") + path
}

function extrairMensagemErroSap(error) {
  return (
    error?.response?.data?.error?.message?.value ||
    error?.response?.data?.error?.message ||
    error?.message ||
    "Falha ao gravar no SAP."
  )
}

//====== Depósito: WarehouseCode é a chave primária no SAP (até 8 caracteres) — diferente de Grupo
// de Item/PN, aqui É o código que o usuário definiu na grade que vai pro SAP, não um gerado pelo
// servidor. Um código inválido (vazio, maior que 8, já usado por outro depósito) volta como erro
// real do SAP — nunca adivinhado por código aqui.
// @return {Promise<{codigo:string, nome:string}>}
export async function gravarDepositoSap(serviceLayerUrl, deposito) {
  try {
    const { data } = await apiSap.post(sapUrl(serviceLayerUrl, "/Warehouses"), {
      WarehouseCode: String(deposito.codigo || "").trim(),
      WarehouseName: deposito.nome,
    })
    return { codigo: data.WarehouseCode, nome: data.WarehouseName }
  } catch (error) {
    throw new Error(extrairMensagemErroSap(error))
  }
}

//====== Grupo de Item: o código (Number) é atribuído PELO PRÓPRIO SAP na criação — o `codigo` que
// a IA sugeriu na grade é só um placeholder de referência, nunca é enviado. O código real volta na
// resposta e substitui o placeholder na tela.
// @return {Promise<{codigo:string, nome:string}>}
export async function gravarGrupoItemSap(serviceLayerUrl, grupo) {
  try {
    const { data } = await apiSap.post(sapUrl(serviceLayerUrl, "/ItemGroups"), {
      GroupName: grupo.nome,
    })
    return { codigo: String(data.Number), nome: data.GroupName }
  } catch (error) {
    throw new Error(extrairMensagemErroSap(error))
  }
}

//====== Grupo de Parceiro de Negócio: mesmo caso do Grupo de Item (código atribuído pelo SAP), mas
// precisa do papel (Type) — o SAP não tem um grupo que sirva pros dois ao mesmo tempo, por isso
// `grupo.papel` já precisa estar em "cliente"/"fornecedor" (nunca "ambos") ao chegar aqui — ver
// preRequisitosLogic.precisaEscolherPapel, que barra a gravação antes de chamar esta função.
//
// WR data 01/10/2026 — Motivo da alteração: reportado ao vivo — "Property 'GroupName' of
// 'BusinessPartnerGroup' is invalid". Diferente de ItemGroups (que usa mesmo "GroupName"), a
// entidade BusinessPartnerGroups deste tenant usa "Name"/"Type" — confirmado contra o que
// buscarGruposParceiroSap (smartflowSapWrite.js) já lê com sucesso ($select=Code,Name,Type) há
// mais tempo. Corrigido pra usar os nomes de campo certos.
// @return {Promise<{codigo:string, nome:string}>}
export async function gravarGrupoPnSap(serviceLayerUrl, grupo) {
  const Type = grupo.papel === "fornecedor" ? "bbpgt_VendorGroup" : "bbpgt_CustomerGroup"
  try {
    const { data } = await apiSap.post(sapUrl(serviceLayerUrl, "/BusinessPartnerGroups"), {
      Name: grupo.nome,
      Type,
    })
    return { codigo: String(data.Code), nome: data.Name }
  } catch (error) {
    throw new Error(extrairMensagemErroSap(error))
  }
}
